import React, { useState } from "react"
import Img from "gatsby-image"
import styled from "styled-components"
import "babel-polyfill"

import Template from "../templates/template"
import { Container } from "../styles/theme"
import media from "../styles/media"

import banner from "../assets/images/img-principal.jpg"
import descuentos from "../assets/images/municipios/descuentos-info.png"

import ModalMunicipio from "../components/ModalCondition"
import "../assets/css/index.css"

const ContentWrapper = styled.div`
  background: #202122;
  & .content {
    background: white;
    margin: 0 60px;
    padding: 10px 35px;
    letter-spacing: -1px;
    color: #6e6e6e;
    ${media.md`
      margin: 0;
    `};
  }
  & .link {
    color: #fff;
    text-decoration: underline;
  }
`
const Franja = styled.div`
  text-align: center;
  background: #202122;
  border-radius: 2px;
  padding-left: 35px;
  padding-right: 35px;
  padding: 10px 35px;
  letter-spacing: -1px;
  color: #6e6e6e;

  & p {
    font-size: 20px;
    color: #fff;
    line-height: 1.8;
    margin: 15px auto;
    padding: 0 40px;
    letter-spacing: 1px;
  }
  & a {
    text-transform: uppercase;
    font-family: "Muller";
    font-weight: 500;
    font-style: normal;
    letter-spacing: 1px;
    padding: 13px 20px;
    color: #202122;
    font-size: 20px;
    margin-top: 0;
    background: #999a9f;
    background: -moz-linear-gradient(
      -45deg,
      #999a9f 0%,
      #999a9f 21%,
      #b0b0b3 21%,
      #b0b0b3 48%,
      #cbcacb 48%,
      #cbcacb 100%
    );
    background: -webkit-linear-gradient(
      -45deg,
      #999a9f 0%,
      #999a9f 21%,
      #b0b0b3 21%,
      #b0b0b3 48%,
      #cbcacb 48%,
      #cbcacb 100%
    );
    background: linear-gradient(
      135deg,
      #999a9f 0%,
      #999a9f 21%,
      #b0b0b3 21%,
      #b0b0b3 48%,
      #cbcacb 48%,
      #cbcacb 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#999a9f', endColorstr='#cbcacb',GradientType=1 );
    display: inline-block;
  }
`

const Municipio = styled.div`
  text-align: center;
  padding-top: 10px;
  min-height: 160px !important;

  & .block-content {
    min-height: 160px;
    text-align: center;
    padding-top: 10px;
  }
  & .inner {
    font-family: "Muller";
    font-weight: 300;
    font-style: normal;
    text-align: center;
    font-size: 14px;
    color: #000000;

    & p {
      font-size: 14px;
    }

    & .img-logo {
      width: 80%;
      height: 80%;
      left: 0px;
      right: 0px;
      margin: auto;
    }
  }

  & .instructions {
    font-size: 12px;
    color: #666666;
    text-decoration: none;
  }

  ${media.sm`
    min-height: auto !important;
  `};

  ${media.xs`
    min-height: 125px !important;
  `};
`

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)"
  }
}
const ImpuestosMunicipales = (props) => {
  const [isOpen, setIsOpen] = useState(false)

  function toggleModal() {
    setIsOpen(!isOpen)
  }

  const municipios = props.data.allMunicipiosCsv.edges.map(
    ({ node: { id, name, url, image, instructions, classAnalitics } }) => {
      const logo = props.data.allImageSharp.edges.find(
        ({
          node: {
            sizes: { originalName }
          }
        }) => {
          return originalName === image
        }
      )
      return (
        <div>
          <Municipio
            className="col-md-3 col-sm-4 col-xs-6 block-content"
            key={id}
          >
            <a
              href={url}
              className={"inner " + classAnalitics}
              data-store={name}
              target="_blank"
            >
              <Img className="img-logo" sizes={logo.node.sizes} alt={name} />
              <p>{name}</p>
            </a>
          </Municipio>
        </div>
      )
    }
  )

  const subtitle = "1% de descuento."
  const title = "Paga tu impuesto predial en línea con"
  return (
    <Template banner={banner} title={title} subtitle={subtitle} active="municipales">
      {({ handleModalShow }) => (
        <ContentWrapper className="row">
          <Container className="title">
            <div className="row">
              <div className="col-md-12">
                <p>Descuentos por pronto pago de impuesto predial urbano</p>
                <img src={descuentos} />
                <p>
                  Realice su pago en estos municipios usando{" "}
                  <a
                    id="CORPIMP_MPAL_NEWKEY"
                    className="link"
                    onClick={toggleModal}
                  >
                    {" "}
                    la nueva clave temporal.
                  </a>
                  <ModalMunicipio
                    onAfterOpen={false}
                    isOpen={isOpen}
                    onRequestClose={toggleModal}
                    ariaHideApp={false}
                    contentLabel="ModalMunicipio"
                  />
                </p>
              </div>
            </div>
          </Container>
          <Container className="content">
            <div className="row">{municipios}</div>
          </Container>
          <Franja>
            <div class="row">
              <div class="col-lg-12">
                <div class="contenido2-caja-contenedor">
                  <p class="contenido2-txt2 text-center">
                    Además recuerde que puede pagar sus impuestos acercándose
                    directamente a ventanillas en los siguientes municipios.
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="text-center">
                  <a
                    href="https://diners-ecuador.s3.amazonaws.com/documents/listado_municipios_corporativo.pdf"
                    target="_blank"
                    class="link-block btn-default-impuestos btn-default-impuestos-uppercase"
                    id="CORPIMP_MPAL_CONOZCA"
                  >
                    Ver Municipios
                  </a>
                </div>
              </div>
            </div>
          </Franja>
        </ContentWrapper>
      )}
    </Template>
  )
}

export default ImpuestosMunicipales

export const query = graphql`
  query municipios {
    allMunicipiosCsv {
      edges {
        node {
          id
          name
          url
          image
          instructions
          classAnalitics
        }
      }
    }
    allImageSharp {
      edges {
        node {
          sizes {
            base64
            tracedSVG
            aspectRatio
            src
            srcSet
            srcWebp
            srcSetWebp
            sizes
            originalImg
            originalName
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js